<svg-icon class="h-5 w-5" preserveAspectRatio="none" [src]="icon" [stretch]="true"></svg-icon>
<div><ng-content></ng-content></div>
@if (tipId && !permanent) {
  <svg-icon
    id="close-icon"
    src="close"
    preserveAspectRatio="none"
    [stretch]="true"
    [ngbTooltip]="buildTranslationKey('closeAndDontShow') | translate"
    [tooltipClass]="'default-tooltip tip-tooltip' + ' ' + tooltipPosition"
    [placement]="tooltipPosition"
    (click)="closeTip()"
  ></svg-icon>
}
